import script from "./SystemSet.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemSet.vue?vue&type=script&setup=true&lang=js"

import "./SystemSet.vue?vue&type=style&index=0&id=76781af8&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76781af8"]])

export default __exports__